// Loading screen: the dictionary's indexes (lib/lexicon.ts warmLexicon) — the lexicon, the form index
// install, its folded lookup and the search index — so the first search or analysed word later costs
// nothing. Waits for the data (state/actions initApp); with no dictionary on the device yet (a first
// start offline) the step fails, and the app goes on as before.
import { defineWarmup } from '../shell/warmup/step';

export const warmup = defineWarmup({
  id: 'dictionary',
  order: 100,
  label: 'dictionary',
  async run({ appReady, progress, pause }) {
    await appReady;
    const { warmLexicon } = await import('../lib/lexicon');
    await warmLexicon(progress, pause);
  },
});
